import { isMobileDevice } from '@/util/getDeviceType'

// Sync with IB
export default {
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkDeviceType)
    this.setZendeskStyleSnippet()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceType)
    this.removeZendeskStyleSnippet()
  },
  watch: {
    isMobile() {
      this.setZendeskStyleSnippet()
    },
  },
  methods: {
    checkDeviceType() {
      this.isMobile = isMobileDevice()
    },
    setZendeskStyleSnippet() {
      this.removeZendeskStyleSnippet()
      this.zendeskStyleSnippet = document.createElement('style')
      this.zendeskStyleSnippet.setAttribute('type', 'text/css')

      this.zendeskStyleSnippet.innerHTML = `
        @media (max-height: 700px) {
          div[style*="visibility: visible"]:not(:has(iframe[style*="position: fixed"][style*="width: 100%"][style*="height: 100%"])) {
            position: fixed;
            right: 0;
            bottom: 0;
            z-index: 999999;
            transform: scale(0.7) !important;
            transform-origin: right top !important;
          }
        }

        @media (max-width: 600px) {
          div[style*="visibility: visible"]:not(:has(iframe[style*="position: fixed"][style*="width: 100%"][style*="height: 100%"])) {
            position: fixed;
            right: 0;
            bottom: 0;
            z-index: 999999;
            transform: scale(0.7) !important;
            transform-origin: right top !important;
          }
        }
      `

      if (!this.isMobile) {
        this.zendeskStyleSnippet.innerHTML += `
          /* max-height: none when chatbox icon hidden */
          div[style*="visibility: visible"] iframe[title][name][style*="width: 380px"][style*="max-height: none"] {
            max-height: calc(100vh - 32px) !important;
          }

          @media (min-width: 768px) {
            div[style*="visibility: visible"] iframe[title][name][style*="width: 380px"][style*="max-height: calc(100vh - 104px)"] {
              width: 750px !important;
              max-height: calc(100vh - 104px) !important;
            }
          }
        `
      }

      document.head.appendChild(this.zendeskStyleSnippet)
    },
    removeZendeskStyleSnippet() {
      if (this.zendeskStyleSnippet) {
        this.zendeskStyleSnippet?.parentNode?.removeChild(this.zendeskStyleSnippet)
      }
    },
  },
}
